import React, { useEffect, useState } from 'react';
import SelectField from './SelectField';

import './DateInput.scss';

export default (props) => {

  const [day, setDay] = useState(null);
  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);

  const [readOnly, setReadOnly] = useState(false);


  const isValidDate = (year, month, day) => {
    month = month - 1;
    var d = new Date(year, month, day);
    if (d.getFullYear() === parseInt(year) && d.getMonth() === parseInt(month) && d.getDate() === parseInt(day)) {
      return true;
    }
    return false;
  }

  const parseDayAndMonth = val => {
    if (!val) return val;
    return val.toString().length === 1 ? `0${val}` : val
  }

  function validateResponse(day, month, year) {
    let today = new Date();
    let maxDate = new Date();
    maxDate.setYear(maxDate.getFullYear() - 120);
    let inputDate = new Date(`${year}-${parseDayAndMonth(month)}-${parseDayAndMonth(day)}T00:00:01Z`);

    let response = {};
    if (!day && !month && !year) {
      response = {
        isValid: true,
        date: inputDate
      };
    } else {
      if (day && month && year && ((year + "").length !== 4) && inputDate) {
        response = {
          isValid: false,
          error: "Please enter a valid date 1"
        };
      } else if (!isValidDate(year, month, day)) {
        response = {
          isValid: false,
          error: "Please enter a valid date 2"
        };
      } else if (day && month && year && inputDate) {
        if (inputDate === "Invalid Date") {
          response = {
            isValid: false,
            error: "Please enter a valid date 3"
          };
        } else {
          if (inputDate >= props.minDate && inputDate < today) {
            response = {
              isValid: false,
              error: "You must be over 18 to enter"
            };
          } else if (inputDate <= maxDate) {
            response = {
              isValid: false,
              error: "Please enter a valid date of birth"
            };
          } else {
            if (inputDate > today) {
              response = {
                isValid: false,
                error: "Please enter a valid date of birth"
              };
            } else {
              response = {
                isValid: true,
                date: inputDate
              };
            }
          }
        }
      } else {
        response = {
          isValid: false
        };
      }
    }

    props.onChange(response);

  }

  useEffect(() => {
    var readonlyDay = "";
    var readonlyMonth = "";
    var readonlyYear = "";

    if (props.value !== null && props.value.date !== undefined) {
      readonlyDay = props.value.date.getDate();
      readonlyMonth = props.value.date.getMonth();
      readonlyYear = props.value.date.getFullYear();

      setDay(parseDayAndMonth(readonlyDay));
      setMonth(parseDayAndMonth(readonlyMonth + 1));
      setYear(readonlyYear);

      validateResponse(readonlyDay, readonlyMonth, readonlyYear);
    }

    setReadOnly(props.readonly);

  }, [props.readonly]);

  useEffect(() => {
    let today = new Date();
    let maxDate = new Date();
    maxDate.setYear(maxDate.getFullYear() - 120);

    let inputDate = new Date(`${year}-${parseDayAndMonth(month)}-${parseDayAndMonth(day)}T00:00:01Z`);

    let response = {};
    if (!day && !month && !year) {
      response = {
        isValid: true,
        date: inputDate
      };
    } else {
      if (day && month && year && ((year + "").length !== 4) && inputDate) {
        response = {
          isValid: false,
          error: "Please enter a valid date"
        };
      } else if (!isValidDate(year, month, day)) {
        response = {
          isValid: false,
          error: "Please enter a valid date"
        };
      } else if (day && month && year && inputDate) {
        if (inputDate === "Invalid Date") {
          response = {
            isValid: false,
            error: "Please enter a valid date"
          };
        } else {
          if (inputDate >= props.minDate && inputDate < today) {
            response = {
              isValid: false,
              error: "You must be over 18 to enter"
            };
          } else if (inputDate <= maxDate) {
            response = {
              isValid: false,
              error: "Please enter a valid date of birth"
            };
          } else {
            if (inputDate > today) {
              response = {
                isValid: false,
                error: "Please enter a valid date of birth"
              };
            } else {
              response = {
                isValid: true,
                date: inputDate
              };
            }
          }
        }
      } else {
        response = {
          isValid: false
        };
      }
    }

    props.onChange(response);

  }, [day, month, year]);

  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const months = [
    { name: "January" },
    { name: "February" },
    { name: "March" },
    { name: "April" },
    { name: "May" },
    { name: "June" },
    { name: "July" },
    { name: "August" },
    { name: "September" },
    { name: "October" },
    { name: "November" },
    { name: "December" }
  ];

  const years = Array.from({ length: 108 }, (_, i) => 1900 + i).reverse();


  return <>

    <div className="date-input">
      <div className='date-input__label'>Date of birth</div>
      <div className='date-input__dates'>
        <SelectField
          id="day"
          autoComplete="bday-day"
          pattern="[0-9]*"
          type="number"
          onChange={setDay}
          placeholder="Day"
          value={day}
          readonly={readOnly}
        >
          <option defaultValue hidden >{readOnly ? day : "Day"}</option>
          {days.map(day => (
            <option key={day} value={day}>{day}</option>
          ))}

        </SelectField>
        <SelectField
          id="month"
          autoComplete="bday-month"
          pattern="[0-9]*"
          inputmode="numeric"
          type="number"
          onChange={setMonth}
          placeholder="Month"
          value={month}
          readonly={readOnly}
        >
          <option defaultValue hidden >{readOnly ? months.find((_, index) => index === month - 1).name : "Month"}</option>
          {months.map((month, index) => (
            <option key={index} value={index + 1}>{month.name}</option>
          ))}
        </SelectField>
        <SelectField
          id="year"
          autoComplete="bday-year"
          pattern="[0-9]*"
          inputmode="numeric"
          type="number"
          onChange={setYear}
          placeholder="Year"
          value={year}
          readonly={readOnly}
        >
          <option defaultValue hidden >{readOnly ? year : "Year"}</option>
          {years.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </SelectField>
      </div>
    </div>
  </>
}